import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TechCheckService } from 'src/app/_services/_techCheck/tech-check.service';

export enum EXTENDED_TECH_CHECK_TYPE {
  JOIN_BBB,
  WATCH_STREAM,
  TROUBLE_BBB,
}

@Component({
  selector: 'app-extended-tech-check',
  templateUrl: './extended-tech-check.component.html',
  styleUrls: ['./extended-tech-check.component.scss'],
})
export class ExtendedTechCheckComponent implements OnInit {
  checkType: EXTENDED_TECH_CHECK_TYPE;
  bbbURL: string;
  isLoading = true;

  constructor(
    private techCheckService: TechCheckService,
    @Inject(MAT_DIALOG_DATA) public data: { checkType: EXTENDED_TECH_CHECK_TYPE },
    private dialog: MatDialogRef<ExtendedTechCheckComponent>
  ) {}

  ngOnInit(): void {
    if (this.data.checkType === EXTENDED_TECH_CHECK_TYPE.JOIN_BBB) {
      this.techCheckService
        .checkBBB(window.location.hostname)
        .then((res) => {
          this.bbbURL = res.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.dialog.close();
          console.log(err);
          alert('Could not load Workshop.');
        });
    } else {
      this.isLoading = false;
    }
  }
}
